"use client";

import { Sparkles } from "lucide-react";

const AnimatedOwl = () => {
  return (
    <div className="text-center mb-12">
      <div className="inline-block mb-6 transform hover:scale-110 transition-transform duration-300">
        <div className="relative">
          <div className="w-32 h-32 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg animate-pulse">
            <img
              className="text-6xl animate-bounce"
              src="/logo.png"
              alt="Owl"
            />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-red-400 rounded-full flex items-center justify-center animate-spin">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <div className="transform hover:scale-105 transition-transform duration-300">
          <h1 className="text-2xl font-bold text-purple-700 mb-2 animate-fade-in">
            TG Tots
          </h1>
          <p className="text-lg text-purple-600 font-medium">Welcomes you to</p>
        </div>

        <h2 className="text-5xl md:text-6xl font-black bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 bg-clip-text text-transparent animate-pulse">
          Draw, Learn, Play!
        </h2>

        <p className="text-xl text-gray-700 mt-4 animate-fade-in-up">
          Learn new words in English and Telugu through fun drawing challenges!
        </p>
      </div>
    </div>
  );
};

export default AnimatedOwl;
